import axios from "axios";

const SUBMIT_FORM = "SUBMIT_FORM";
const SUBMIT_FORM_SUCCESS = "SUBMIT_FORM_SUCCESS";
const SUBMIT_FORM_FAILURE = "SUBMIT_FORM_FAILURE";

const initialState = {
  success: false,
  data: null,
  loading: false,
  error: null,
};

const submitSuccess = (data) => ({
  type: SUBMIT_FORM_SUCCESS,
  payload: data,
});

const submitFailure = (error) => ({
  type: SUBMIT_FORM_FAILURE,
  payload: error,
});

export const fetchSubmitForm = (form) => async (dispatch) => {
  dispatch({ type: SUBMIT_FORM });

  try {
    const res = await axios.post(
      "https://caredoc-fe-server.herokuapp.com/application",
      form
    );
    const data = res.data;
    await dispatch(submitSuccess(data));
    await console.log(data.message);
  } catch (err) {
    await dispatch(submitFailure(err));
    await console.log(err);
  }
};

export default function submit(state = initialState, action) {
  switch (action.type) {
    case SUBMIT_FORM:
      return {
        ...state,
        loading: true,
      };
    case SUBMIT_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload,
      };
    case SUBMIT_FORM_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
}
